var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.isProp && _vm.isOn) ||_vm.getSpinnerStatus),expression:"(isProp && isOn) ||getSpinnerStatus"}],staticClass:"loadingSpinner"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }